// extracted by mini-css-extract-plugin
module.exports = {"Button":"kvuPUd49otr6I6oPPmBIyw==","Success":"_3U6IwkIjy3vxAznM1vbM7w==","Primary":"xXHMc2c1bf5xjPYnE+2Z4Q==","Danger":"GkhGhu-bVfOhRy-F5jGJ-Q=="};